import { Button } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n.consumers';

import './custom-hazard-menu.styl';

function CustomHazardMenu({ id, icon }) {
  const { t } = useTranslation();

  return (
    <Button
      className="custom-hazard-menu__select-option"
      icon={icon}
    >
      {t(id)}
    </Button>
  );
}

export default CustomHazardMenu;